﻿/**
* DevExpress Analytics (core\internal\_papperKindMapper.js)
* Version:  21.2.8
* Build date: Jun 7, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.papperKindMapper = {
    A2: { width: 1654, height: 2339 },
    A3: { width: 1169, height: 1654 },
    A3Extra: { width: 1268, height: 1752 },
    A3ExtraTransverse: { width: 1268, height: 1752 },
    A3Rotated: { width: 1654, height: 1169 },
    A3Transverse: { width: 1169, height: 1654 },
    A4: { width: 827, height: 1169 },
    A4Extra: { width: 929, height: 1268 },
    A4Plus: { width: 827, height: 1299 },
    A4Rotated: { width: 1169, height: 827 },
    A4Small: { width: 827, height: 1169 },
    A4Transverse: { width: 827, height: 1169 },
    A5: { width: 583, height: 827 },
    A5Extra: { width: 685, height: 925 },
    A5Rotated: { width: 827, height: 583 },
    A5Transverse: { width: 583, height: 827 },
    A6: { width: 413, height: 583 },
    A6Rotated: { width: 583, height: 413 },
    APlus: { width: 894, height: 1402 },
    B4: { width: 984, height: 1390 },
    B4Envelope: { width: 984, height: 1390 },
    B4JisRotated: { width: 1433, height: 1012 },
    B5: { width: 693, height: 984 },
    B5Envelope: { width: 693, height: 984 },
    B5Extra: { width: 791, height: 1087 },
    B5JisRotated: { width: 1012, height: 717 },
    B5Transverse: { width: 717, height: 1012 },
    B6Envelope: { width: 693, height: 492 },
    B6Jis: { width: 504, height: 717 },
    B6JisRotated: { width: 717, height: 504 },
    BPlus: { width: 1201, height: 1917 },
    C3Envelope: { width: 1276, height: 1803 },
    C4Envelope: { width: 902, height: 1276 },
    C5Envelope: { width: 638, height: 902 },
    C65Envelope: { width: 449, height: 902 },
    C6Envelope: { width: 449, height: 638 },
    CSheet: { width: 1700, height: 2200 },
    DLEnvelope: { width: 433, height: 866 },
    DSheet: { width: 2200, height: 3400 },
    ESheet: { width: 3400, height: 4400 },
    Executive: { width: 725, height: 1050 },
    Folio: { width: 850, height: 1300 },
    GermanLegalFanfold: { width: 850, height: 1300 },
    GermanStandardFanfold: { width: 850, height: 1200 },
    InviteEnvelope: { width: 866, height: 866 },
    IsoB4: { width: 984, height: 1390 },
    ItalyEnvelope: { width: 433, height: 906 },
    JapaneseDoublePostcard: { width: 787, height: 583 },
    JapaneseDoublePostcardRotated: { width: 583, height: 787 },
    JapanesePostcard: { width: 394, height: 583 },
    Ledger: { width: 1700, height: 1100 },
    Legal: { width: 850, height: 1400 },
    LegalExtra: { width: 927, height: 1500 },
    Letter: { width: 850, height: 1100 },
    LetterExtra: { width: 927, height: 1200 },
    LetterExtraTransverse: { width: 927, height: 1200 },
    LetterPlus: { width: 850, height: 1269 },
    LetterRotated: { width: 1100, height: 850 },
    LetterSmall: { width: 850, height: 1100 },
    LetterTransverse: { width: 827, height: 1100 },
    MonarchEnvelope: { width: 388, height: 750 },
    Note: { width: 850, height: 1100 },
    Number10Envelope: { width: 412, height: 950 },
    Number11Envelope: { width: 450, height: 1038 },
    Number12Envelope: { width: 475, height: 1100 },
    Number14Envelope: { width: 500, height: 1150 },
    Number9Envelope: { width: 388, height: 888 },
    PersonalEnvelope: { width: 362, height: 650 },
    Prc16K: { width: 575, height: 846 },
    Prc16KRotated: { width: 575, height: 846 },
    Prc32K: { width: 382, height: 594 },
    Prc32KBig: { width: 382, height: 594 },
    Prc32KBigRotated: { width: 382, height: 594 },
    Prc32KRotated: { width: 382, height: 594 },
    PrcEnvelopeNumber1: { width: 402, height: 650 },
    PrcEnvelopeNumber10: { width: 1276, height: 1803 },
    PrcEnvelopeNumber10Rotated: { width: 1803, height: 1276 },
    PrcEnvelopeNumber1Rotated: { width: 650, height: 402 },
    PrcEnvelopeNumber2: { width: 402, height: 693 },
    PrcEnvelopeNumber2Rotated: { width: 693, height: 402 },
    PrcEnvelopeNumber3: { width: 492, height: 693 },
    PrcEnvelopeNumber3Rotated: { width: 693, height: 492 },
    PrcEnvelopeNumber4: { width: 433, height: 819 },
    PrcEnvelopeNumber4Rotated: { width: 819, height: 433 },
    PrcEnvelopeNumber5: { width: 433, height: 866 },
    PrcEnvelopeNumber5Rotated: { width: 866, height: 433 },
    PrcEnvelopeNumber6: { width: 472, height: 906 },
    PrcEnvelopeNumber6Rotated: { width: 906, height: 472 },
    PrcEnvelopeNumber7: { width: 630, height: 906 },
    PrcEnvelopeNumber7Rotated: { width: 906, height: 630 },
    PrcEnvelopeNumber8: { width: 472, height: 1217 },
    PrcEnvelopeNumber8Rotated: { width: 1217, height: 472 },
    PrcEnvelopeNumber9: { width: 902, height: 1276 },
    PrcEnvelopeNumber9Rotated: { width: 1276, height: 902 },
    Quarto: { width: 846, height: 1083 },
    Standard10x11: { width: 1000, height: 1100 },
    Standard10x14: { width: 1000, height: 1400 },
    Standard11x17: { width: 1100, height: 1700 },
    Standard12x11: { width: 1200, height: 1100 },
    Standard15x11: { width: 1500, height: 1100 },
    Standard9x11: { width: 900, height: 1100 },
    Statement: { width: 550, height: 850 },
    Tabloid: { width: 1100, height: 1700 },
    TabloidExtra: { width: 1169, height: 1800 },
    USStandardFanfold: { width: 1488, height: 1100 },
};
